import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const InfoWrapper = styled.div`
  display: flex;
  padding: 1rem;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  border: 1px solid #fbeaea;
  background: rgba(251, 234, 234, 0.6);
`;

export const InfoText = styled(Text)`
  color: var(--Neutral-N600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const SlabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  align-items: center;

  margin: ${(props) =>
    props.showError ? "1.5rem 0 0 0" : "1.5rem 0 0.5rem 0"};
`;

export const Slab = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  padding: 14px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #e7e7f0;
  background: #fff;
  cursor: pointer;
  ${(props: { isSelected: any }) =>
    props.isSelected &&
    `
    border: 1px solid  #0FA457;
    background: #F3FAF7;
  `}
`;

export const IconContainer = styled.div`
  display: flex;
  width: 88px;
  height: 88px;
  justify-content: center;
  align-items: center;
`;

export const SlabText = styled(Text)`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #5b5675;

  span {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    color: #040222;
  }
`;

export const Error = styled(Text)`
  color: #d83d37;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 8px;
  min-height: 14px;
  line-height: 18px;
`;
